"use client";

import { FaFacebookF } from "react-icons/fa6";
import { RiYoutubeLine } from "react-icons/ri";
import { GrInstagram } from "react-icons/gr";
import { IoMailSharp } from "react-icons/io5";
import { FaPhone } from "react-icons/fa6";
import { FaLinkedinIn } from "react-icons/fa6";

import Image from "next/image";
import { useRouter } from "next/navigation";

import logo from "@/assets/images/logo.png";
import { useEffect, useState } from "react";
import { CLIENT_API_ROUTES } from "@/utils/clientApiRoutes";
import axios from "axios";
import { IoLogoWhatsapp } from "react-icons/io";
import footerOverlay from "@/assets/images/footer.jpg";

function Footer() {
  const router = useRouter();

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        const [catRes] = await Promise.all([
          await axios.get(CLIENT_API_ROUTES?.GET_SERVICE_SLUG_CATEGORIES),
        ]);

        const categories = catRes?.data?.categories || [];

        setCategories(categories);
      } catch (err) {
        console.error("Error Fetching categories and services:", err?.message);
        setCategories([]);
      }
    };

    getData();
  }, []);

  const handleWhatsapp = () => {
    const phoneNumber = "919314503871";
    const message = "Hi! I am interested in your services.";
    const encodedMessage = encodeURIComponent(message);

    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <>
      <div className="w-full border-t border-t-[#4e677073]">
        <div
          style={{ backgroundImage: `url(${footerOverlay.src})` }}
          className="relative h-full bg-cover bg-no-repeat bg-bottom min-h-[20vh] flex justify-center items-center p-6 md:p-14 w-full "
        >
          {/* Overlay */}
          <div className="absolute inset-0 bg-[#fffffff5]"></div>
          <div className="w-full relative z-2 grid grid-cols-1 md:grid-cols-5 lg:grid-cols-9  gap-4 md:gap-8 ">
            <div className="w-full h-full md:col-span-3  flex flex-col gap-2 md:gap-4 items-start justify-center ">
              <Image
                onClick={() => router.push("/")}
                src={logo}
                alt="Logo"
                className="h-20 w-auto object-contain cursor-pointer"
              />

              <p className="max-w-md text-base md:text-lg">
                Vijay Garg and Associates is a trusted and reliable firm
                specializing in Accounting, Auditing, and Financial Consulting,
                backed by a strong network of professionals across India.
              </p>

              {/* Social icons */}
              <div className="flex gap-1 items-end md:gap-2">
                <a href="mailto:info@vijaygargasso.com" className="text-black">
                  <div className="bg-[#f8982d] cursor-pointer p-2 rounded-full">
                    <IoMailSharp className="text-lg text-white" />
                  </div>
                </a>

                <a href="tel:+919314503871" className="text-black">
                  <div className="bg-blue-600 cursor-pointer p-2 rounded-full">
                    <FaPhone className="text-lg text-white" />
                  </div>
                </a>

                <div onClick={() => handleWhatsapp()} className="text-black">
                  <div className="bg-green-500 cursor-pointer p-2 rounded-full">
                    <IoLogoWhatsapp className="text-lg text-white" />
                  </div>
                </div>

                <a
                  href="https://www.linkedin.com/company/vijay-garg-associates"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-black"
                >
                  <div className="bg-blue-500 cursor-pointer p-2 rounded-full">
                    <FaLinkedinIn className="text-lg text-white" />
                  </div>
                </a>
              </div>
            </div>

            {/* Links */}
            <div className="w-full h-full md:col-span-2  flex flex-col   gap-1 md:gap-2">
              {/* title */}
              <p className="my-1 text-xl md:text-2xl text-primary  font-bold">
                Quick Links
              </p>

              <p
                onClick={() => router.push("/")}
                className="text-lg w-fit cursor-pointer hover:text-blue-400 font-medium md:text-lg text-[#4E6770]"
              >
                Home
              </p>
              <p
                onClick={() => router.push("/about")}
                className="text-lg w-fit  cursor-pointer hover:text-blue-400 font-medium md:text-lg text-[#4E6770]"
              >
                About Us
              </p>

              <p
                onClick={() => router.push("/article")}
                className="text-lg w-fit  cursor-pointer hover:text-blue-400 font-medium md:text-lg text-[#4E6770]"
              >
                Articles
              </p>

              <p
                onClick={() => router.push("/career")}
                className="text-lg w-fit  cursor-pointer hover:text-blue-400 font-medium md:text-lg text-[#4E6770]"
              >
                Careers
              </p>

              <p
                onClick={() => router.push("/gallery")}
                className="text-lg w-fit  cursor-pointer hover:text-blue-400 font-medium md:text-lg text-[#4E6770]"
              >
                Gallery
              </p>
            </div>

            {/* Services */}
            <div className="w-full h-full md:col-span-2  flex flex-col gap-1 md:gap-2">
              {/* title */}
              <p className="my-1 text-xl md:text-2xl text-primary font-bold">
                Services
              </p>

              {categories?.length > 0 &&
                categories?.slice(0, 5)?.map((item, index) => (
                  <p
                    key={index}
                    onClick={() =>
                      (window.location.href = `/services/${item?.slugLink}`)
                    }
                    className="w-fit cursor-pointer hover:text-blue-400  font-medium text-base text-[#445e68]"
                  >
                    {item?.name}
                  </p>
                ))}
            </div>

            {/* Contact */}
            <div className="w-full h-full md:col-span-2  flex flex-col gap-1 md:gap-2">
              {/* title */}
              <p className="my-1 text-xl md:text-2xl text-primary font-bold">
                Contact Us
              </p>

              <a
                href="mailto:info@vijaygargasso.com"
                className="text-lg cursor-pointer font-medium md:text-lg text-[#4E6770]"
              >
                <p className="text-base">Email</p>
                <p className="font-medium hover:text-blue-400">
                  info[at]vijaygargasso.com
                </p>
              </a>

              <div
                onClick={() => handleWhatsapp()}
                className="text-lg cursor-pointer font-medium md:text-lg text-[#4E6770]"
              >
                <p className="text-base">Whatsapp</p>
                <p className="font-medium hover:text-blue-400">+919314503871</p>
              </div>

              <a
                href="https://maps.app.goo.gl/Z1zuoj8D18z3TzLLA"
                target="_blank"
                className="text-lg cursor-pointer font-medium md:text-lg text-[#4E6770]"
              >
                <p className="text-base">Location (HO)</p>
                <p className="font-medium hover:text-blue-400 text-sm">
                  C-121-A Abhyam, 3rd Floor Opp. Jyoti Nagar Police Station, Lal
                  Kothi, Jaipur, Rajasthan 302015
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* CopyRight */}
      <div className="bg-primary min-h-[10vh] p-1 flex flex-col gap-1 justify-center items-center">
        <a
          className="text-red-400 ml-2"
          href="https://khojorightnow.com/"
          target="_blank"
        >
          <p className="text-[#dfd9d9] text-base font-outfit ">
            Design & Developed By
            <span className="font-semibold text-white"> Khojo Right Now </span>
          </p>
        </a>

        <p className="text-[#f8982d] text-base font-outfit ">
          Copyright © {new Date().getFullYear()}. All rights reserved.
        </p>
      </div>
    </>
  );
}

export default Footer;

// bg-[#ffffff05]
